// UTILITY FUNCTIONS

function normalize(text) {
  return text.trim().replace(/\s+/g, ' ').toLowerCase();
}

// PRODUCT PAGE
const productDedupeInterval = setInterval(() => {
  const relatedContainer = document.querySelector('.related-products');
  if (!relatedContainer) return;

  const currentTitleEl = document.querySelector('.product__title h1, .product__title h2');
  const seenTitles = new Set();
  if (currentTitleEl) {
    const currentTitle = normalize(currentTitleEl.textContent);
    seenTitles.add(currentTitle);
  }

  relatedContainer.querySelectorAll('li.slider__slide').forEach(slide => {
    const titleLink = slide.querySelector('.card__heading a');
    if (!titleLink) return;

    const rawTitle = titleLink.textContent.trim();
    const title = normalize(rawTitle);

    if (seenTitles.has(title)) {
      slide.style.display = 'none';
    } else {
      seenTitles.add(title);
      slide.style.display = '';
    }
  });

  clearInterval(productDedupeInterval);
}, 200);

const trimInterval = setInterval(() => {
  const trimEl = document.querySelector('li.sf-book-details__trim');
  if (!trimEl) return;

  trimEl.innerHTML = trimEl.innerHTML
    .replace(/\(\s*[whd]\s*\)/gi, '"')
    .replace(/\s*in\s*$/i, '');

  clearInterval(trimInterval);
}, 200);

function setBuyButtonUnavailable() {
  const buyButton = document.querySelector(
    '.product-form button.product-form__submit[name="add"]',
  );
  if (!buyButton) return;

  const labelSpan = [...buyButton.querySelectorAll("span")].find(
    (span) =>
      !span.closest(".loading__spinner") && !span.classList.contains("hidden"),
  );

  if (labelSpan) {
    labelSpan.textContent = "Unavailable";
  } else {
    buyButton.textContent = "Unavailable";
  }
}

/** Re-apply after other theme scripts and availability calls. */
function enforceBuyButtonUnavailable() {
  const delays = [0, 300, 700, 1200, 2000];

  delays.forEach((delay) => {
    setTimeout(() => setBuyButtonUnavailable(), delay);
  });
}

const internationalLogicInterval = setInterval(() => {
  if (!window.Shopify || window.Shopify.country === "US") {
    clearInterval(internationalLogicInterval);
    return;
  }

  const container = document.querySelector(".sf-formats__buttons");
  const productForm = document.querySelector(".product-form");
  if (!container || !productForm) return;

  const buttons = container.querySelectorAll(".sf-formats__button");
  const currentBtn = container.querySelector(".sf-formats__button.current");
  const isEpubCurrent =
    currentBtn?.textContent.trim().toLowerCase() === "epub";

  buttons.forEach((btn) => {
    const isCurrent = btn.classList.contains("current");
    const isEpub = btn.textContent.trim().toLowerCase() === "epub";

    if (!isCurrent && !isEpub) {
      btn.style.pointerEvents = "none";
      btn.style.opacity = "0.4";
      btn.style.cursor = "not-allowed";
    }
  });

  if (!isEpubCurrent) {
    enforceBuyButtonUnavailable();
  }

  if (!document.querySelector(".sf-international-message")) {
    const msg = document.createElement("div");
    msg.className = "sf-international-message";
    msg.style.marginTop = "1rem";
    msg.innerHTML = `
      <p>
        <strong>E-pubs available worldwide.</strong> To purchase print products outside of the United States, please visit:
        <a href="https://utpdistribution.com/" target="_blank" rel="noopener">UTP Distribution</a> in Canada or
        <a href="https://mngbookshop.co.uk/" target="_blank" rel="noopener">Mare Nostrum</a>
        in the UK, Europe, the Middle East, Africa, and Asia-Pacific.
      </p>
    `;
    productForm.insertAdjacentElement("afterend", msg);
  }

  clearInterval(internationalLogicInterval);
}, 200);
